[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 8,
                "key": "xMSu7"
            },
            {
                "x": 6,
                "y": 7,
                "key": "4St2N"
            },
            {
                "x": 5,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 5,
                "y": 6,
                "key": "RBCT-"
            },
            {
                "x": 5,
                "y": 5,
                "key": "6zmsi"
            },
            {
                "x": 6,
                "y": 5,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 6,
                "y": 3,
                "key": "Y_QtY"
            },
            {
                "x": 8,
                "y": 3,
                "key": "87Arv"
            },
            {
                "x": 8,
                "y": 4,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 11,
                "y": 4,
                "key": "A7-b0"
            },
            {
                "x": 11,
                "y": 5,
                "key": "NjyBq"
            },
            {
                "x": 12,
                "y": 5,
                "key": "zriMH"
            },
            {
                "x": 12,
                "y": 7,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 7,
                "key": "yISFx"
            },
            {
                "x": 11,
                "y": 8,
                "key": "VjHMM"
            },
            {
                "x": 9,
                "y": 8,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 7,
                "y": 8,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]